import styled from "styled-components";

export const Title = styled.h1`
	font-size: 20px;
	font-weight: 700;
	line-height: 23px;
	color: #31475a !important;
`;

export const StatusContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;

	margin-top: 40px;
`;

export const Subtitle = styled(Title)`
	font-size: 18px;
`;

export const StatusSelectContainer = styled.form`
	display: flex;
	align-items: center;
	gap: 16px;
`;

export const StatusLabel = styled.p`
	font-size: 14px;
	line-height: 23px;
	color: #31475a;
`;

export const MainButton = styled.button`
	background: #504c9a;
	border: 1px solid #504c9a;
	padding: 8px 32px;
	color: #fff;
	font-size: 16px;
	line-height: 23px;
	font-weight: bold;
	border-radius: 8px;

	&:disabled {
		background: #e5e5ea;
		border: 1px solid #e5e5ea;
		color: #9f9fa9;
		cursor: not-allowed;
	}
`;

export const Separator = styled.div`
	width: 100%;
	height: 1px;
	background: #e5e5ea;
	margin: ${({ hasMargin = true }) => (hasMargin ? "32px" : "0")} auto;
`;

export const ContractInfoTitleContainer = styled(StatusContainer)`
	margin-top: 32px;
`;

export const ContractInfoContainer = styled.div`
	display: flex;
	flex-direction: column;

	margin-top: 32px;
`;

export const ContractSection = styled.div`
	display: flex;
	flex-direction: column;
	gap: 32px;
`;

export const UpdatesContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 0.05fr 0.9fr;
`;

export const UpdatesCardsContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 24px;
`;

export const ScrollContainer = styled.div`
	overflow-y: auto;
	height: 753px;
	max-height: 753px;
	display: flex;
	flex-direction: column;
	gap: 24px;
`;

export const DocumentsScrollContainer = styled.div`
	overflow-y: auto;
	max-height: 300px;
	display: flex;
	flex-direction: column;
	gap: 16px;
`;

export const VerticalSeparator = styled.div`
	width: 1px;
	height: 100%;
	background: #e5e5ea;
	margin: 0 32px;
`;

export const DocumentsAndCommentsContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 24px;
`;

export const UploadDocumentInputContainer = styled.label`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 10px;
	width: 100%;
	padding: 32px;
	border: 1px dashed #e5e7eb;
	border-radius: 8px;
	cursor: pointer;

	input {
		display: none;
	}
`;

export const UploadDocumentTitle = styled.p`
	color: #31475a !important;
	font-size: 12px;
	line-height: 23px;
	text-align: center;
	margin: 0;
`;

export const UploadDocumentDescription = styled.p`
	color: #9f9fa9 !important;
	font-size: 12px;
	line-height: 23px;
	text-align: center;
	margin: 0;
`;

export const RightSideButtonContainer = styled.div`
	display: flex;
	width: 100%;
	justify-content: flex-end;
`;

export const CommentTextArea = styled.textarea`
	width: 100%;
	height: 100px;
	border: 1px solid #e5e7eb;
	border-radius: 6px;
	padding: 12px;
	resize: none;
	font-size: 14px;

	&::placeholder {
		color: #9f9fa9;
	}

	&:focus {
		outline: none;
	}
`;

export const FileErrorMessage = styled.div`
	color: #dc2626;
	font-size: 12px;
	margin-top: 5px;
`;

export const SolicitationContractContainer = styled(StatusContainer)`
	margin-top: 32px;
`;

export const ContractNameCell = styled.a`
	padding: 16px 0;
	display: flex;
	align-items: center;
	gap: 8px;
	color: #000000;
	text-decoration: none;
	cursor: ${({ clickable }) => (clickable ? "pointer" : "default")};

	&:hover {
		color: #000000;
		text-decoration: none;
	}
`;
